module.exports = __webpack_public_path__ + "img/goods-search.486184a6.svg";